import { space } from '@repo/theme/primitives';
import type { IWidgetSample } from '../../api';
import { WidgetSize, WidgetType } from '../../interfaces';

// eslint-disable-next-line prefer-destructuring
export const HOMEPAGE_MAX_WIDTH = space[200];
// eslint-disable-next-line prefer-destructuring
export const HOMEPAGE_PADDING = space[16];

export const HOMEPAGE_WIDGET_TYPES = [
	WidgetType.INTEGRATIONS,
	WidgetType.TEXT_BLOCK,
	WidgetType.INBOX,
	WidgetType.ANNOUNCEMENTS,
	WidgetType.BOOKMARKED_RESOURCES,
	WidgetType.POPULAR_RESOURCES,
	WidgetType.RECENTLY_EDITED_RESOURCES,
	WidgetType.RECENTLY_ACCESSED_RESOURCES,
	WidgetType.RECENT_SEARCHES,
	WidgetType.DATA_QUALITY_SCORE,
];

export const HOMEPAGE_ALLOWED_WIDGETS_TO_ADD: IWidgetSample[] = [
	...[WidgetType.BOOKMARKED_RESOURCES].map((type) => ({ type })),
	{
		type: WidgetType.AI_GLOSSARY_SUGGESTIONS,
		size: WidgetSize.FULL,
	},
	...[
		WidgetType.POPULAR_COLLECTIONS,
		WidgetType.COLLECTION_RESOURCES,
		WidgetType.INBOX,
		WidgetType.INTEGRATIONS,
		WidgetType.RECENT_SEARCHES,
		WidgetType.ANNOUNCEMENTS,
		WidgetType.HELPFUL_LINKS,
		WidgetType.QUESTIONS_POPULAR,
		WidgetType.DATA_QUALITY_SCORE,
	].map((type) => ({ type })),
	{
		type: WidgetType.TEXT_BLOCK,
		color: 'white',
		title: 'Private notepad',
	},
];

export const TEAM_HOMEPAGE_ALLOWED_WIDGETS_TO_ADD: IWidgetSample[] = [
	...[
		WidgetType.BOOKMARKED_RESOURCES,
		WidgetType.POPULAR_COLLECTIONS,
		WidgetType.COLLECTION_RESOURCES,
		WidgetType.INTEGRATIONS,
		WidgetType.DATA_QUALITY_SCORE,
	].map((type) => ({ type })),
	{
		type: WidgetType.TEXT_BLOCK,
		color: 'white',
		title: 'Notepad',
	},
];

export const COLLECTIONS_WIDGETS: WidgetType[] = [
	WidgetType.COLLECTION_RESOURCES,
	WidgetType.POPULAR_COLLECTIONS,
	WidgetType.BOOKMARKED_COLLECTIONS,
];
